import { useEffect, useState } from "react";
import { Container } from "./style";
import { AuthApi } from "../../api/Auth.api";
import Error from "../../models/Error.model";
import { ERROR_TYPE } from "../../commons/Const";
import TextFieldView from "../../components/commons/TextField.view";
import { useLocation, useNavigate } from "react-router-dom";
import { UserApi } from "../../api/User.api";
import MessageModal from "../../components/modal/Message.modal";

export default function ResetPasswordPage() {

  const location = useLocation()
  const navigate = useNavigate()
  
  let token = ''

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [passwordMessage, setPasswordMessage] = useState('')
  const [confirmPasswordMessage, setConfirmPasswordMessage] = useState('')

  useEffect(() => {
    return () => {
      //initToken(null)
    }
  }, [])

  useEffect(() => {
    if(location.state === null) {
      alert('유효하지 않은 접근입니다.')
      navigate({pathname: '/signin'}, {replace: true})
      return
    }

    //initToken(location.state.token)

  }, [location])

  useEffect(() => {
    if(password !== '') setPasswordMessage('')
  }, [password])

  useEffect(() => {
    if(confirmPassword === '') return

    if(password === confirmPassword) setConfirmPasswordMessage('')
    else setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
  }, [password, confirmPassword])

  const resetPassword = () => {

    let isNext = true
    
    if(password === '') {
      setPasswordMessage('비밀번호를 입력해주세요.')
      isNext = false
    }

    if(password !== confirmPassword) {
      setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
      isNext = false
    }

    if(!isNext) return

    AuthApi.resetPassword(password)
    .then(result => {
      window.history.replaceState({}, document.title)
      alert('비밀번호 재설정이 완료되었습니다. 로그인 화면으로 이동합니다.')
      navigate('/signin')
    }).catch(console.error)
  }

  return (
    <Container>
      <div className="inner page_inner">
        <p className="page_title"><span>비밀번호 재설정</span></p>
        <section>
          <TextFieldView
            value={password}
            onChange={setPassword}
            title="비밀번호"
            type="password"
            placeholder="비밀번호"
            errorMessage={passwordMessage}
            styles={{
              marginBottom: 36
            }}
          />

          <TextFieldView
            value={confirmPassword}
            onChange={setConfirmPassword}
            title="비밀번호 확인"
            type="password"
            placeholder="비밀번호 확인"
            errorMessage={confirmPasswordMessage}
          />

          <button className="contained_main btn_reset"
            onClick={resetPassword}
          >
            <strong className="fs16">재설정하기</strong>
          </button>
        </section>
      </div>
      {/* <MessageModal
        title="알림"
        message="비밀번호 재설정이 완료되었습니다."
        onClicmConfirm={() => {

        }}
      /> */}
    </Container>
  )
}